import { render } from "./LessonItem.vue?vue&type=template&id=f0b42510"
import script from "./LessonItem.vue?vue&type=script&lang=js"
export * from "./LessonItem.vue?vue&type=script&lang=js"

import "./LessonItem.vue?vue&type=style&index=0&id=f0b42510&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__